import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "nav",
  class: "navbar"
}
const _hoisted_2 = { class: "navbar__group navbar__group--left" }
const _hoisted_3 = { class: "navbar__item navbar__item--left" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "navbar__logo" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "navbar__menu"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-angle-down" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "navbar__menu"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-angle-right" }, null, -1)
const _hoisted_9 = { class: "navbar__group navbar__group--center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-calendar" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Calendrier ")
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "icon-calendar" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Séries ")
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon-trophy" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Classement ")
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-team" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Équipes ")
const _hoisted_18 = { id: "favorites" }
const _hoisted_19 = {
  key: 0,
  class: "navbar__link",
  ref: "favorite-dropdown"
}
const _hoisted_20 = {
  key: 1,
  class: "navbar__link",
  ref: "captain-dropdown"
}
const _hoisted_21 = { class: "navbar__group  navbar__group--right" }
const _hoisted_22 = { class: "navbar__item navbar__item--right" }
const _hoisted_23 = {
  key: 0,
  id: "usermenu__link"
}
const _hoisted_24 = {
  key: 0,
  class: "notifications-indicator"
}
const _hoisted_25 = { class: "user__name" }
const _hoisted_26 = {
  key: 1,
  class: "register__container"
}
const _hoisted_27 = {
  id: "login__link",
  class: "button button--action"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "icon-login" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "text--long" }, "Connexion", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-eye" }),
  /*#__PURE__*/_createTextVNode(" Saison: ")
], -1)
const _hoisted_31 = { class: "season__name" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "icon-cancel" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_TeamLabel = _resolveComponent("TeamLabel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "navbar__title",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleMainMenu()), ["stop"]))
        }, [
          _hoisted_4,
          (_ctx.mainMenuVisible)
            ? (_openBlock(), _createBlock("span", _hoisted_5, [
                _hoisted_6
              ]))
            : (_openBlock(), _createBlock("span", _hoisted_7, [
                _hoisted_8
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      (_ctx.emptySchedule || _ctx.rankingProvisional)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            id: "schedule",
            to: "/schedule"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            id: "schedule",
            to: "/series"
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          })),
      _createVNode(_component_router_link, {
        id: "ranking",
        to: "/ranking"
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _hoisted_15
        ]),
        _: 1
      }),
      (_ctx.teamsIFavorite.length == 0)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            id: "teams",
            to: "/teams"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _hoisted_17
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_18, [
        (_ctx.teamsIFavorite.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: `/teams/${_ctx.teamsIFavorite[0].name}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TeamLabel, {
                    team: _ctx.teamsIFavorite[0],
                    favorite: true
                  }, null, 8, ["team"]),
                  (_ctx.teamsIFavorite.length > 1)
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: "icon-angle-down",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTeamFavoritesDropdown && _ctx.showTeamFavoritesDropdown(...args)), ["prevent","stop"]))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to"])
            ], 512))
          : _createCommentVNode("", true),
        (_ctx.teamsICaptain.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: `/teams/${_ctx.teamsICaptain[0].name}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TeamLabel, {
                    team: _ctx.teamsICaptain[0],
                    captain: true
                  }, null, 8, ["team"]),
                  (_ctx.teamsICaptain.length > 1)
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: "icon-angle-down",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTeamCaptainDropdown && _ctx.showTeamCaptainDropdown(...args)), ["prevent","stop"]))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to"])
            ], 512))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        (_ctx.isLoggedIn)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _createVNode("span", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.toggleUserMenu()), ["stop"]))
              }, [
                _createVNode("div", {
                  class: "user__role--wrapper",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.toggleNotifications()), ["stop"]))
                }, [
                  _createVNode("img", {
                    class: "user__role",
                    src: _ctx.userRoleImg
                  }, null, 8, ["src"]),
                  (_ctx.hasNotifications)
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _createVNode("span", null, _toDisplayString(_ctx.notifications.length), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("span", _hoisted_25, _toDisplayString(_ctx.user), 1),
                _createVNode("i", {
                  class: {
                        'icon-angle-down': _ctx.userMenuVisible,
                        'icon-angle-right': !_ctx.userMenuVisible
                       }
                }, null, 2)
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("span", {
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.toggleLoginDialog(true)), ["stop"]))
                }, [
                  _hoisted_28,
                  _hoisted_29
                ])
              ])
            ]))
      ])
    ]),
    (_ctx.archiveView)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          id: "season__view",
          class: "button button--action button--error",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearArchiveView()))
        }, [
          _hoisted_30,
          _createVNode("span", _hoisted_31, [
            _createVNode("span", null, _toDisplayString(_ctx.seasonName[0]), 1),
            (_ctx.seasonName[1])
              ? (_openBlock(), _createBlock("span", _hoisted_32, _toDisplayString(_ctx.seasonName[1]), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_33
        ]))
      : _createCommentVNode("", true)
  ]))
}